import React, { useState } from 'react';
import PropTypes from 'prop-types';

import LoadingWrapper from 'dpl/components/LoadingWrapper';
import {
  BUYER_APPLICATIONS_PATH,
  BREEDER_DASHBOARD_PATH
} from 'dpl/shared/constants/urls';
import { SUCCESSFUL_SUBMISSION_APPLICATION_ID } from 'dpl/constants/query_params';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import { addToQuery } from 'dpl/util/queryString';

import AdoptionApplicationContext from '../utils/context';
import ApplicationLayoutContainer from '../containers/ApplicationLayoutContainer';

export default function ApplicationEntry({
  buyerApplicationData,
  isLoadingData,
  onApplicationBeforeSubmit,
  onApplicationSubmit,
  onCloseClick
}) {
  const { isBreeder } = useCurrentUser();
  // HACK: need to wait for quiz submission AND refetch as an atomic operation
  // in order to make sure buyer application data is inferred and saved properly
  // before progressing to next question
  const [isSubmittingAndRefetching, setIsSubmittingAndRefetching] =
    useState(false);

  const {
    value: {
      buyer_application: { id: applicationId, submitted_at: submittedAt } = {}
    }
  } = buyerApplicationData;

  if (applicationId && submittedAt) {
    const BASE_PATH = isBreeder
      ? BREEDER_DASHBOARD_PATH
      : BUYER_APPLICATIONS_PATH;
    window.location.href = `${BASE_PATH}?${addToQuery(
      {
        [SUCCESSFUL_SUBMISSION_APPLICATION_ID]: applicationId
      },
      ''
    )}`;
    return null;
  }
  return (
    <div className="AdoptionApplicationEntry">
      <LoadingWrapper
        isLoading={isLoadingData}
        className="fixed absolute--fill bg-white"
      >
        <AdoptionApplicationContext.Provider
          value={{
            isSubmittingAndRefetching,
            setIsSubmittingAndRefetching
          }}
        >
          <ApplicationLayoutContainer
            onCloseClick={onCloseClick}
            onBeforeSubmit={onApplicationBeforeSubmit}
            onSubmit={onApplicationSubmit}
            /* HACK: passing as a prop directly to use in withFormCapabilities */
            isSubmittingAndRefetching={isSubmittingAndRefetching}
          />
        </AdoptionApplicationContext.Provider>
      </LoadingWrapper>
    </div>
  );
}

ApplicationEntry.propTypes = {
  buyerApplicationData: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.shape({ buyer_application: PropTypes.object }).isRequired
  }).isRequired,
  isLoadingData: PropTypes.bool.isRequired,
  onApplicationBeforeSubmit: PropTypes.func.isRequired,
  onApplicationSubmit: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired
};
